<template>
  <transition name="fade">
    <div class="level3-modal-container" v-if="pemilikSahamData">
      <div class="lv3-title-text">
        {{
          $store.state.addEdit.isAddPemilikSaham
            ? 'Tambah Pemilik Saham'
            : 'Edit Pemilik Saham'
        }}
      </div>
      <div class="lv3-edit-form" style="overflow-y: hidden !important">
        <div class="edit-form-wrapper">
          <div>Nama Pemilik Saham</div>
          <input class="lv3-input-text" :placeholder="inputName" type="text" v-model="inputName"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>% Saham</div>
          <input class="lv3-input-text" :placeholder="inputSaham" type="number" v-model="inputSaham" />
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="delData()" v-if="!$store.state.addEdit.isAddPemilikSaham">
            DELETE
          </div>
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="confirm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['propsData'],
  data() {
    return {
      email: null,
      customText: null,
      tempText: null,
      id: '',
      vendor_id: '',
      name: '',
      saham: 0,
    }
  },
  computed: {
    pemilikSahamData() {
      const pemilikSaham = this.$store.state.addEdit.pemilikSahamDetail
      if (pemilikSaham) {
        this.id = pemilikSaham.id
        this.vendor_id = pemilikSaham.vendor_id
        this.name = pemilikSaham.nama
        this.saham = pemilikSaham.persen ? pemilikSaham.persen : 0
      }
      return true
    },
    inputName: {
      get() {
        return this.name
      },
      set(newValue) {
        this.name = newValue
      },
    },
    inputSaham: {
      get() {
        return this.saham
      },
      set(newValue) {
        this.saham = Number(newValue)
      },
    },
  },
  methods: {
    closeModal() {
      const self = this
      self.$store.commit('modalStore/SET_SAHAM_MODAL', false)
    },
    checkForm() {
      let arr = [
        [this.inputName, 'Silahkan Mengisi Nama Pemilik Saham Dengan Benar'],
        [
          Number(this.saham) + Number(this.$store.state.addEdit.totalSaham) <=
          100,
          'Total Saham melebihi 100%',
        ],
      ]

      return this.multiCustomConditions(arr)
    },
    confirm() {
      if (this.checkForm()) {
        this.submit()
      }
    },
    submit() {
      if (this.$store.state.addEdit.isAddPemilikSaham) {
        this.$store.dispatch('addEdit/addPemilikSaham', {
          id: this.id,
          vendor_id: this.vendor_id,
          name: this.name,
          persen: this.saham,
          onSuccess: () => {
            this.$store.commit('level1/GET_INFO_DATA', 'informasi')
          },
        })
      } else {
        this.$store.dispatch('addEdit/editPemilikSaham', {
          id: this.id,
          vendor_id: this.vendor_id,
          name: this.name,
          persen: this.saham,
          onSuccess: () => {
            this.$store.commit('level1/GET_INFO_DATA', 'informasi')
          },
        })
      }
    },
    delData() {
      this.$store.dispatch('addEdit/deletePemilikSaham', {
        id: this.id,
        onSuccess: () => {
          this.$store.commit('level1/GET_INFO_DATA', 'informasi')
        },
      })
    },
  },
}
</script>
